const TrustpilotStar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={128}
    height={24}
    viewBox="0 0 128 24" // Add the viewBox here
    fill="none"
    aria-label="Trustpilot star rating"
    {...props}
  >
    <path
      fill="#00B67A"
      d="M24 0H0v24h24V0Zm26 0H26v24h24V0Zm26 0H52v24h24V0Zm26 0H78v24h24V0Z"
    />
    <path fill="#DCDCE6" d="M128 0h-12v24h12V0Z" />
    <path fill="#00B67A" d="M116 0h-12v24h12V0Z" />
    <path
      fill="#fff"
      d="m12 16.18 3.65-.93 1.53 4.7L12 16.18Zm8.4-6.08h-6.42L12 4.05l-1.97 6.05H3.6l5.2 3.75-1.97 6.05 5.2-3.75 3.2-2.3 5.17-3.75ZM38 16.18l3.65-.93 1.53 4.7L38 16.18Zm8.4-6.08h-6.42L38 4.05l-1.97 6.05H29.6l5.2 3.75-1.97 6.05 5.2-3.75 3.2-2.3 5.17-3.75ZM64 16.18l3.65-.93 1.53 4.7L64 16.18Zm8.4-6.08h-6.42L64 4.05l-1.97 6.05H55.6l5.2 3.75-1.97 6.05 5.2-3.75 3.2-2.3 5.17-3.75ZM90 16.18l3.65-.93 1.53 4.7L90 16.18Zm8.4-6.08h-6.42L90 4.05l-1.97 6.05H81.6l5.2 3.75-1.97 6.05 5.2-3.75 3.2-2.3 5.17-3.75Zm17.6 6.08 3.65-.93 1.52 4.7-5.17-3.77Zm8.4-6.08h-6.43L116 4.05l-1.97 6.05h-6.43l5.2 3.75-1.97 6.05 5.2-3.75 3.2-2.3 5.17-3.75Z"
    />
  </svg>
);
export default TrustpilotStar;
